<fieldset [disabled]="formState==='Submitting'">
  <form [formGroup]="multiPayment" class="mpmt" >

      <mat-radio-group  class="mpmt-payments" formControlName="payment">
      <div *ngFor="let item of this.contractStep.multi_payment_data" class="mpmt-payments-item">
        <div class="mpmt-payments-item-first">

          <div class="mpmt-payments-item-first-amount">
            <mat-radio-button [disableRipple]="true" [value]="item.payment_guid" class="mpmt-payments-item-first-amount-selector">
            </mat-radio-button>
            <div class="mpmt-payments-item-first-amount-label">
              {{item.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru'}}
            </div>

          </div>
          <div class="mpmt-payments-item-first-icons" >
              <mat-icon class="base-icon" svgIcon="file-search-fill" style="width: 20px;cursor: pointer;"
                [matTooltip]="'CONTRACTS.CARD.VIEW'|translate"
                (click)="viewPayment(item.payment_guid)"> 
              </mat-icon>
              <mat-icon class="base-icon" svgIcon="edit-2-fill" style="width: 20px;cursor: pointer;"
                [matTooltip]="'CONTRACTS.CARD.EDIT'|translate"
                [class.disabled]="contractData?.rights?.isContractBlockedForEdit === true" 
                (click)="editPayment(item.payment_guid, item)"> 
              </mat-icon>
              <mat-icon class="base-icon" svgIcon="delete-bin-5-fill" style="width: 20px; cursor: pointer;"
                [matTooltip]="'CONTRACTS.CARD.DELETE'|translate"
                [class.disabled]="contractData?.rights?.isContractBlockedForEdit === true" 
                (click)="deletePayment(item.payment_guid)"> 
              </mat-icon>
          </div>
        </div>
        <div class="mpmt-payments-item-second">
          {{'CONTRACTS.CARD.PAYMENT.MULTI_MSG' | translate}}
        </div>
        <div class="mpmt-payments-item-third">
          <div class="mpmt-payments-item-third-dg">
            <img class="mpmt-payments-item-third-dg-img" 
              *ngIf="!contractAvatarsService.contractGenericAvatarMap.get(item?.payer_guid)&&!contractAvatarsService?.contractAvatarMap?.get(item?.payer_guid)"
              [src]="
              contractAvatarsService?.contractAvatarMap?.get(item?.payer_guid)?.img||
              '../../../../../assets/images/contract/fotos/'+(avatarsMocks[item?.payer_guid]?.img
              ||'random3.jpg')">
            <app-contract-avatar 
              *ngIf="contractAvatarsService.contractGenericAvatarMap.get(item?.payer_guid)||contractAvatarsService?.contractAvatarMap?.get(item?.payer_guid)"
              [avatarSize]="'36px'"
              [userGuid]="item?.payer_guid" 
              [checkedState]="false"
              >
            </app-contract-avatar>
            <img class="mpmt-payments-item-third-dg-icon" [src]="'../../../../../assets/images/contract/payment-status/arrow-right-line-16.svg'">
            <img class="mpmt-payments-item-third-dg-img" 
              *ngIf="!contractAvatarsService.contractGenericAvatarMap.get(item?.recipient_guid)&&!contractAvatarsService?.contractAvatarMap?.get(item?.recipient_guid)"
              [src]="
              contractAvatarsService?.contractAvatarMap?.get(item?.recipient_guid)?.img||
              '../../../../../assets/images/contract/fotos/'+(avatarsMocks[item?.recipient_guid]?.img
              ||'random3.jpg')">
            <app-contract-avatar 
              *ngIf="contractAvatarsService.contractGenericAvatarMap.get(item?.recipient_guid)||contractAvatarsService?.contractAvatarMap?.get(item?.recipient_guid)"
              [avatarSize]="'36px'"
              [userGuid]="item?.recipient_guid" 
              [checkedState]="false"
              >
            </app-contract-avatar>
          </div>
          <div class="mpmt-payments-item-third-users" *ngIf="contractStep?.membersAvatarsToShow && contractAvatarsService?.contractAvatarMap">
            <app-contract-avatar *ngFor="let member of contractStep?.membersAvatarsToShow"
              [avatarSize]="'36px'"
              [userGuid]="member.guid" 
              [checkedState]="signedPayments.includes(item.payment_guid + '_' + member.guid)"
              class="mpmt-payments-item-third-users-avatar"
              >
            </app-contract-avatar>
          </div>
        </div>
      </div>
    </mat-radio-group>
    <div class="button-block">
      <button  class="button-icon size-m primary-button" data-action="signOnOffPayment" 
        (click)="signOnOffPayment()"
        [disabled]="
          this.contractData.rights.isCurrentMemberCanAddTargetsAfter === false ||
          (!payment?.value) ||
          (
            membersSignedPayment.includes(contractDataService.currentMember?.guid) &&
            signedPayments?.includes((payment?.value||'') + '_'+ contractDataService.currentMember?.guid) === false
          ) "
        >
        <mat-icon [svgIcon]="signedPayments?.includes((payment?.value||'')+'_'+ contractDataService.currentMember?.guid)?'arrow-go-back-fill':'checkbox-multiple-fill'"></mat-icon>
          <span>
            {{(signedPayments?.includes((payment?.value||'') + '_'+ contractDataService.currentMember?.guid)? 'CONTRACTS.CARD.RECALL' : 'CONTRACTS.CARD.APPROVE') |translate}}
          </span>
      </button>

      <button  class="button-icon size-m secondary-button" data-action="addPayment" 
        [disabled]="contractData?.rights?.isContractBlockedForEdit === true"
        (click)="addPayment()">
        <mat-icon svgIcon="add-circle-fill" > </mat-icon>
        <span> {{'CONTRACTS.CARD.ADD'|translate}}</span>
      </button>
  </div>
    
 </form>
<div class="attention-block" *ngIf="stepTartget?.isSignPaymentsALot">{{ 'CONTRACTS.TEXT.SIGN_PAYMENT' | translate}}</div>
</fieldset>